const clearNotifications = (store) => store.set([]);

export default clearNotifications;
